import { useContext, useState } from "react";
import { IFinancialFilterProps } from "../../../../@interfaces";
import InputDate from "../../../../components/inputdate"
import ModalFilters, { ContentFilter, RowSection, SeparatorFilter } from "../../../../components/modalfilters"
import ToastContext from "../../../../contexts/toast";
import moment from "moment";
import Subtitle from "../../../../components/subtitle";

const DateFilter: React.FC<IFinancialFilterProps> = ({ currentStartDate, currentEndDate, defaultStartDate, defaultEndDate, applyFilter, cleanFilter, handleClose }) => {
  const [startDate, setStartDate] = useState<string>(currentStartDate);
  const [endDate, setEndDate] = useState<string>(currentEndDate);

  const { showErrorToast } = useContext(ToastContext);


  function handleStartDateChange(event: React.FormEvent<HTMLInputElement>) {
    setStartDate(event.currentTarget.value)
  }




  function handleEndDateChange(event: React.FormEvent<HTMLInputElement>) {
    setEndDate(event.currentTarget.value);
  }




  function handleApplyFilter() {
    if (moment(endDate).isBefore(startDate)) {
      showErrorToast("Data inicial posterior a data final");
      return;
    }

    applyFilter(startDate, endDate);
  }




  function handleCleanFilter() {
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    cleanFilter();
  }




  return (
    <ModalFilters applyFilter={handleApplyFilter} cleanFilter={handleCleanFilter} handleClose={handleClose}>
      <ContentFilter>
        {/* <OptionsContainer>
          <FilterOption> */}
        <Subtitle className='!text-[16px] !mb-4'>Período</Subtitle>
        <RowSection>
          <InputDate
            value={startDate}
            onChange={handleStartDateChange}
            label="Início"
            type={"date"}
            max={endDate}
            inputStyle={{ width: 160, background: '#fff' }}
            containerStyle={{ width: 170 }}
          />


          <InputDate
            value={endDate}
            onChange={handleEndDateChange}
            label="Fim"
            type={"date"}
            min={startDate}
            inputStyle={{ width: 160, background: '#fff' }}
            containerStyle={{ width: 170 }}
          />
        </RowSection>
        {/* </FilterOption>

          <FilterOption>
            <TextInput />
          </FilterOption>
        </OptionsContainer> */}
        <SeparatorFilter />
      </ContentFilter>
    </ModalFilters>
  )
}


export default DateFilter;